// object with the basic styles
const colors = {
  greyF0: "#F0F0F0", // Light
  greyE6: '#e6e6e6', // Use for disable
  teal1: "#005A4B", // Darkest
  teal2: "#008273", // Main Tjeders green
  teal5: "#D7EBEB",
  blue1: "#009BAF",
  blue1hover: "#006c80",
  blue3: "#B9E6E6",
  yellow1: "#FFC84B",
  signalRed: "#E6373C",
  white: '#FFFFFF',
};

const size = {
  radius: "15px",
};

const primary = {
  color: colors.teal1,
  background: colors.blue3,
  disabled: colors.greyE6,
  borderColor: colors.yellow1,
  hover: colors.yellow1,
  disabledColor: colors.white,
  borderRadius: size.radius,
};
const secondary = {
  color: colors.teal1,
  background: colors.yellow1,
  disabled: colors.grey,
  borderColor: colors.yellow1,
  hover: colors.yellow1,
  disabledColor: colors.darkGrey,
  borderRadius: size.radius,
};

const distress = {
  color: colors.signalRed,
  background: colors.blue3,
  disabled: colors.grey,
  borderColor: colors.signalRed,
  hover: colors.signalRed,
  disabledColor: colors.darkGrey,
  borderRadius: size.radius,
};

const distressactive = {
    color: colors.teal1,
    background: colors.signalRed,
    disabled: colors.grey,
    borderColor: colors.signalRed,
    hover: colors.signalRed,
    disabledColor: colors.darkGrey,
    borderRadius: size.radius,
  };

const blue = {
  color: colors.teal1,
  background: colors.blue3,
  hover: colors.blue1,
  disabled: colors.greyD0,
  borderColor: colors.blue1,
  disabledColor: colors.darkGrey,
  borderRadius: size.radius,
};

const buttons = {
  primary,
  secondary,
  distress,
  blue,
  distressactive,
};


const mainTheme = {
  buttons,
  colors,

};

export default mainTheme;